import { createStore } from 'framework7';
import { http } from '../api/config.js';

const carLoanRating = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
//End mutations

    async getRatingForLender({ dispatch }, { referenceId, fromId }) {
      let response = [];
      let result = {};

      result = await http.get(`rating/lender/${referenceId}/${fromId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async getRatingForBorrower({ dispatch }, { referenceId, fromId }) {
      let response = [];
      let result = {};

      result = await http.get(`rating/borrower/${referenceId}/${fromId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async getLastRating({ dispatch }, userId) {
      let response = [];
      let result = {};

      result = await http.get(`rating/last/lender/${userId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async ratingLender({ dispatch }, data) {
      let response = [];
      let result = {};
  
      result = await http.post(`loan/lender/rating`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 201) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async ratingBorrower({ dispatch }, data) {
      let response = [];
      let result = {};
  
      result = await http.post(`loan/borrower/rating`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 201) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },
  },
  getters: {
    Item({ state }) {
      return state.item;
    }
  },
});

export default carLoanRating;
